import { HStack, Tag, Text, VStack } from "@chakra-ui/react";

type TagRowProps = {
  items: string[];
  /** Small mono caption above the row; omit for an unlabelled row. */
  label?: string;
  /** "outline" is the focus-area chip, "solid" the technical-skill chip. */
  variant?: "outline" | "solid";
};

const VARIANTS = {
  outline: {
    bg: "transparent",
    borderColor: "whiteAlpha.200",
    color: "whiteAlpha.600",
  },
  solid: {
    bg: "whiteAlpha.100",
    borderColor: "whiteAlpha.300",
    color: "whiteAlpha.800",
  },
} as const;

// Shared by the experience and involvement sections so both chip rows stay identical.
export default function TagRow({
  items,
  label,
  variant = "outline",
}: TagRowProps) {
  if (items.length === 0) return null;

  return (
    <VStack align="flex-start" spacing={2.5}>
      {label && (
        <Text
          fontFamily="mono"
          fontSize="10px"
          letterSpacing="0.14em"
          textTransform="uppercase"
          color="whiteAlpha.400"
        >
          {label}
        </Text>
      )}

      <HStack spacing={2} flexWrap="wrap" rowGap={2}>
        {items.map((item) => (
          <Tag
            key={item}
            border="1px solid"
            borderRadius="full"
            fontFamily="mono"
            fontSize="xs"
            letterSpacing="0.06em"
            px={3}
            py={1}
            {...VARIANTS[variant]}
          >
            {item}
          </Tag>
        ))}
      </HStack>
    </VStack>
  );
}
